module.exports = __webpack_public_path__ + "static/media/plant.5a05716e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/plant.jpg
// module id = 1931
// module chunks = 108